module.exports = __webpack_public_path__ + "static/playstore-c1e7b2d64942a220d3b5e2ea32b5109a.svg";